import React, { createContext, useContext, useState, useCallback } from "react"
import { isEqual, isFunction } from "lodash"
import {IS_ACTIVE, IS_ACTIVE_INIT_VALUE} from "./../store/constants"

const DCIUIContext = createContext()

export function useDCIUIContext() {
  return useContext(DCIUIContext)
}

export const DCIUIConsumer = () => DCIUIContext.Consumer

export function DCIUIProvider({ dciUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState({[IS_ACTIVE]:IS_ACTIVE_INIT_VALUE})
  const [ids, setIds] = useState([])
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams)
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams
      }

      return nextQueryParams
    })
  }, [])

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    ...dciUIEvents
  }

  return (
    <DCIUIContext.Provider value={value}>
      {children}
    </DCIUIContext.Provider>
  )
}
